(function () {
  'use strict';
  if (window.top !== window || window.gaNewsletterMeasurementV1 || !document.querySelector('.ga-newsletter-page')) return;
  window.gaNewsletterMeasurementV1 = true;
  var sent = {};
  var form, visible = false, viewTimer, observer, mutations, poll;
  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }
  function send(type) {
    if (sent[type] || !allowed() || document.hidden) return false;
    var preview = !window.Shopify || !window.Shopify.theme || window.Shopify.theme.role !== 'main';
    var data = {
      send_to: 'G-GTDP3JFKMX',
      content_group: 'newsletter',
      content_id: 'PtXH45',
      content_placement: 'newsletter_embed',
      source_page: window.location.pathname,
      page_location: window.location.origin + window.location.pathname,
      universe_environment: preview ? 'preview' : 'live'
    };
    // The list uses double opt-in. A form submission is not a confirmed subscription.
    if (type === 'submit') data.subscription_status = 'confirmation_required';
    if (preview) data.debug_mode = true;
    window.dataLayer = window.dataLayer || [];
    function event() { window.dataLayer.push(arguments); }
    event('event', type === 'submit' ? 'newsletter_form_submit' : 'newsletter_form_view', data);
    sent[type] = true;
    return true;
  }
  function cancelView() { if (viewTimer) clearTimeout(viewTimer); viewTimer = null; }
  function scheduleView() {
    if (sent.view || viewTimer || !visible || !allowed() || document.hidden) return;
    viewTimer = setTimeout(function () {
      viewTimer = null;
      if (visible && send('view')) {
        if (observer) observer.disconnect();
        if (poll) clearInterval(poll);
      }
    }, 1000);
  }
  function findForm() {
    if (form || !window.IntersectionObserver) return;
    var container = document.querySelector('.ga-newsletter-page .klaviyo-form-PtXH45');
    // A placeholder is not a form impression. Wait for the real embed controls.
    if (!container || !container.querySelector('input')) return;
    form = container;
    if (mutations) mutations.disconnect();
    observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== form) return;
        visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        if (!visible) cancelView();
        scheduleView();
      });
    }, {threshold:[0,0.25]});
    observer.observe(form);
  }
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail;
    if (!detail || detail.formId !== 'PtXH45' || detail.companyId !== 'MC76rC') return;
    if (detail.type === 'embedOpen') findForm();
    // Never replay submissions made without analytics consent.
    if (detail.type === 'submit') send('submit');
  });
  if (window.MutationObserver) {
    mutations = new window.MutationObserver(findForm);
    mutations.observe(document.querySelector('.ga-newsletter-page'), {childList:true,subtree:true});
  }
  findForm();
  document.addEventListener('visitorConsentCollected', function () { cancelView(); scheduleView(); });
  document.addEventListener('visibilitychange', function () { cancelView(); scheduleView(); });
  var attempts = 0;
  poll = setInterval(function () {
    attempts++;
    scheduleView();
    if (allowed() || attempts >= 20) clearInterval(poll);
  }, 500);
})();
